import { SCOPE_PREVIEW } from '../constants/local_storage'

// Same in-tab notification trick as jwtStorage: the native `storage` event only
// reaches other tabs.
export const SCOPE_PREVIEW_CHANGE_EVENT = 'scopePreviewChange'

/** The raw stored value, or null when no preview is active. */
function read(): string | null {
  try {
    return localStorage.getItem(SCOPE_PREVIEW)
  } catch (e) {
    console.error('[scopePreviewStorage] Failed to read', e)
    return null
  }
}

function write(scopes: string[]): void {
  try {
    localStorage.setItem(SCOPE_PREVIEW, JSON.stringify(scopes))
    window.dispatchEvent(new Event(SCOPE_PREVIEW_CHANGE_EVENT))
  } catch (e) {
    console.error('[scopePreviewStorage] Failed to write', e)
  }
}

function clear(): void {
  try {
    localStorage.removeItem(SCOPE_PREVIEW)
    window.dispatchEvent(new Event(SCOPE_PREVIEW_CHANGE_EVENT))
  } catch (e) {
    console.error('[scopePreviewStorage] Failed to clear', e)
  }
}

export const scopePreviewStorage = { get: read, set: write, clear }
